module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-500italic.ce14fc7e.eot";